import React from 'react';

const SectionExamenes = ({ children }) => (
  <section id="examenes">
    {children}
  </section>
);

export default SectionExamenes;
